import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';
import { Room as S } from './styles';

class RoomInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: true,
    };
  }
  toggleCollapse = () => {
    this.setState(prevState => ({
      collapse: !prevState.collapse,
    }));
  };
  render() {
    const { room } = this.props;
    const { collapse } = this.state;
    return (
      <S.Info>
        <button onClick={() => this.toggleCollapse()}>
          <span>About this room</span>
          {collapse ? <Icon type="caret-down" /> : <Icon type="caret-up" />}
        </button>
        {!collapse ? (
          <div className="details">
            <h3>{room.desc}</h3>
            <div>
              <p>{room.listOne}</p>
              <p>{room.listTwo}</p>
            </div>
          </div>
        ) : null}
      </S.Info>
    );
  }
}

RoomInfo.propTypes = {
  room: PropTypes.object.isRequired,
};

export default RoomInfo;



// WEBPACK FOOTER //
// ./src/containers/Hotel/RoomInfo.js